import React, { useContext, useState } from "react";
import styled from "styled-components";
import { StyleUtils } from "../../../../../helper/Style/StyleUtils";
import { ThemeContext } from "../../../../theme/ThemeContextProvider";
export const StyledTextInput = styled.input `
  outline: none;
  height: ${props => StyleUtils.getNormalizedPixelString(props.height)};
  width: ${props => StyleUtils.getNormalizedPixelString(props.width)};
  font-size: ${props => StyleUtils.getNormalizedPixelString(props.fontSize)};
  line-height: ${props => StyleUtils.getNormalizedPixelString(props.fontSize)};
  text-align: ${props => props.textAlign};
  background-color: ${props => getVariableColor(props.backgroundColor, props.isInFocus)};
  color: ${props => getVariableColor(props.fontColor, props.isInFocus)};
  font-weight: ${props => props.fontWeight};
  margin: ${props => StyleUtils.getNormalizedArrayPixelString(props.margin)};
  border-width: ${props => StyleUtils.getNormalizedArrayPixelString(props.borderWidth)};
  border-color: ${props => getVariableColor(props.borderColor, props.isInFocus)};
  border-radius: ${props => StyleUtils.getNormalizedArrayPixelString(props.borderRadius)};
  border-style: ${props => props.borderStyle};
  padding: ${props => StyleUtils.getNormalizedArrayPixelString(props.padding)};
  ::placeholder {
    color: ${props => getVariableColor(props.placeholderColor, props.isInFocus)}
  }
  &::-ms-reveal {
    display: none;
  }
`;
const getVariableColor = (color, isInFocus) => {
    if (typeof color === "string") {
        return color;
    }
    else {
        return isInFocus ? color.inFocus : color.normal;
    }
};
const TextInput = (props) => {
    const { index, initialValue = "", className = "text-input", placeholder = "Input", type = "text", filterRegex, maxLength = 100, height = 16, width = 160, fontSize = 14, backgroundColor = "#FFFFFF", placeholderColor = "#757575", fontColor = "#000000", fontWeight = "normal", textAlign = "left", margin = 0, borderWidth = 1, borderColor = "#000000", borderRadius = 0, borderStyle = "solid", padding = 0, handleSubmit, handleChange, handleFocus, handleBlur } = props;
    const [isInFocus, setIsInFocus] = useState(false);
    const [value, setValue] = useState(initialValue);
    const { theme: contextTheme } = useContext(ThemeContext);
    const theme = contextTheme;
    const onFocus = (e) => {
        setIsInFocus(true);
        if (handleFocus) {
            handleFocus(index);
        }
    };
    const onBlur = (e) => {
        setIsInFocus(false);
        if (handleBlur) {
            handleBlur(index);
        }
    };
    const onKeyPress = (e) => {
        const charCode = e.charCode;
        switch (charCode) {
            case 13: { //Enter
                if (handleSubmit) {
                    handleSubmit(value, index);
                }
                break;
            }
        }
    };
    const onChange = (e) => {
        var _a;
        const newValue = ((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) || "";
        setValue(prevState => {
            if (newValue.length > maxLength) {
                return prevState;
            }
            if (!!filterRegex) {
                if (filterRegex.test(newValue)) {
                    return newValue;
                }
                else {
                    if (!newValue) {
                        return newValue;
                    }
                    else {
                        return prevState;
                    }
                }
            }
            else {
                if (handleChange) {
                    handleChange(newValue, index);
                }
                return newValue;
            }
        });
    };
    return (React.createElement(StyledTextInput, { className: className, type: type, placeholder: placeholder, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onChange: onChange, value: value, isInFocus: isInFocus, height: height, width: width, fontSize: fontSize, backgroundColor: backgroundColor, placeholderColor: placeholderColor, fontColor: fontColor, fontWeight: fontWeight, textAlign: textAlign, margin: margin, borderWidth: borderWidth, borderColor: borderColor, borderRadius: borderRadius, borderStyle: borderStyle, padding: padding }));
};
export default TextInput;
